'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../util/interfaces.js');
require('../util/user.constants.js');
var normalize = require('../util/normalize.js');
require('../util/date.js');
require('../util/static-content.js');
var index = require('../adapter/index.js');
var getAmlVerificationStatus = require('../adapter/users/getAmlVerificationStatus.js');
var userPendingConsents = require('../adapter/users/userPendingConsents.js');
var util = require('./util.js');
var session = require('../session/session.js');

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const API_ERRORS = {
  INVALID_VERIFICATION_CODE: "INVALID_VERIFICATION_CODE"
};
class Users {
  addNote(note) {
    return index.adapter.users.addNote({ note });
  }
  getBankIdiFrameDetails(params) {
    return index.adapter.users.getBankIdiFrameDetails(params);
  }
  getSportncoLaunchURL(params) {
    return index.adapter.users.getSportncoLaunchURL(params);
  }
  getProfile() {
    return index.adapter.users.getProfile();
  }
  getProfileV2() {
    return index.adapter.users.getProfileV2();
  }
  updateProfile(profile) {
    return index.adapter.users.updateProfile(profile);
  }
  updateProfileV2(profile) {
    return index.adapter.users.updateProfileV2(profile);
  }
  agreedCompliance(username) {
    const user = session.session.getUser();
    if (!user && !username) {
      throw new Error("User not logged in or no userId given to agreedCompliance call.");
    }
    const params = { userName: username || user.userName };
    return index.adapter.users.agreedCompliance(params);
  }
  getCountries() {
    return __async(this, null, function* () {
      const countries = yield index.adapter.users.getCountries();
      countries.countries = countries.countries.filter((country) => !!country).sort((a, b) => a.name.localeCompare(b.name));
      countries.countries = countries.countries.filter((country, i) => i === 0 || countries.countries[i - 1].code !== country.code);
      return countries;
    });
  }
  login(username, pwd) {
    return __async(this, null, function* () {
      const params = {
        usernameOrEmail: username,
        password: pwd
      };
      const user = yield index.adapter.users.login(params);
      session.session.create(user);
      this.subscribeForTags(user);
      return user;
    });
  }
  logout() {
    const response = index.adapter.users.logout();
    session.session.destroy();
    return response;
  }
  loginV2(username, pwd, lang, oneTimePassword, geoResponse) {
    return __async(this, null, function* () {
      const params = {
        usernameOrEmail: username,
        password: pwd,
        lang,
        oneTimePassword,
        geoResponse
      };
      const user = yield index.adapter.users.loginV2(params);
      session.session.create(user);
      this.subscribeForTags(user);
      return user;
    });
  }
  getSportncoToken() {
    return __async(this, null, function* () {
      return yield index.adapter.users.getSportncoToken();
    });
  }
  authenticateWithChallengeToken(token, userId, fromUserId) {
    return __async(this, null, function* () {
      const user = yield index.adapter.users.authenticateWithChallengeToken({
        challengeToken: token,
        userId,
        fromUserId
      });
      session.session.create(user);
      this.subscribeForTags(user);
      return user;
    });
  }
  resumeLogin() {
    return __async(this, null, function* () {
      try {
        const user = yield index.adapter.users.resumeLogin();
        session.session.create(user);
        this.subscribeForTags(user);
        return user;
      } catch (e) {
        session.session.destroy();
        return null;
      }
    });
  }
  resumeLoginV2() {
    return __async(this, null, function* () {
      try {
        const user = yield index.adapter.users.resumeLoginV2();
        session.session.create(user);
        this.subscribeForTags(user);
        return user;
      } catch (e) {
        session.session.destroy();
        return null;
      }
    });
  }
  isLoggedIn() {
    return index.adapter.users.isLoggedIn();
  }
  completeRegistration(params) {
    return index.adapter.users.completeRegistration(params);
  }
  resendVerificationEmail(email) {
    return index.adapter.users.resendVerificationEmail({
      email
    });
  }
  signup(params, lang, quick, transparentErrors, geoResponse) {
    return index.adapter.users.signup(params, lang, quick, transparentErrors, geoResponse);
  }
  signupV2(params) {
    return index.adapter.users.signupV2(params);
  }
  resetPasswordRequestV1(email, language) {
    return index.adapter.users.resetPasswordRequestV1({ email, lang: language });
  }
  resetPasswordRequest(params) {
    return index.adapter.users.resetPasswordRequest(params);
  }
  resetPassword(password, key) {
    const params = {
      password,
      key
    };
    return index.adapter.users.resetPassword(params);
  }
  sendResetPasswordSMS(mobilePrefix, mobileNumber) {
    const params = {
      mobilePrefix,
      mobile: mobileNumber
    };
    return index.adapter.users.sendResetPwdSMS(params);
  }
  resetPasswordSMS(mobilePrefix, mobileNumber, recoveryCode, newPassword) {
    const params = {
      mobilePrefix,
      mobile: mobileNumber,
      recoveryCode,
      password: newPassword
    };
    return index.adapter.users.resetPasswordSMS(params);
  }
  changePassword(oldPassword, newPassword, verificationCode) {
    return __async(this, null, function* () {
      const params = {
        oldPassword,
        newPassword,
        verificationCode
      };
      try {
        const result = yield index.adapter.users.changePassword(params);
        return result;
      } catch (error) {
        if (error === API_ERRORS.INVALID_VERIFICATION_CODE && !verificationCode) {
          yield this.sendSMS();
        }
        return Promise.reject(error);
      }
    });
  }
  verifySMS(mobile, mobileVerificationCode, mobilePrefix) {
    const params = {
      Mobile: mobile,
      MobileVerificationCode: mobileVerificationCode,
      MobilePrefix: mobilePrefix
    };
    return index.adapter.users.verifySMS(params);
  }
  getConsents(lang) {
    return __async(this, null, function* () {
      const consents = yield index.adapter.users.getConsents({
        languageAlpha2Code: lang
      });
      return consents.map((consent) => __spreadProps(__spreadValues({}, consent), {
        consented: consent.consented || false,
        consentContents: consent.consentContents.find(({ languageAlpha2Code }) => languageAlpha2Code === lang)
      }));
    });
  }
  getUserConsents(lang) {
    return __async(this, null, function* () {
      const consents = yield index.adapter.users.getUserConsents({
        languageAlpha2Code: lang
      });
      return consents.userConsents.map((consent) => __spreadProps(__spreadValues({}, consent), {
        consented: consent.consented || false,
        consentContents: consent.consentContents.find(({ languageAlpha2Code }) => languageAlpha2Code === lang)
      }));
    });
  }
  detailsUpdateRequested() {
    return index.adapter.users.detailsUpdateRequest();
  }
  saveUserConsents(userConsents, userName, userId) {
    if (userId && !userName) {
      throw new Error("Must supply username if supplying user ID");
    }
    const promises = [
      index.adapter.users.saveUserConsents({
        userConsents,
        userId
      })
    ];
    const onsiteConsent = userConsents.find(({ name }) => {
      return name === userPendingConsents.ConsentName.ONSITE_MARKETING;
    });
    if (onsiteConsent) {
      promises.push(this.setUserOnSiteMarketing(onsiteConsent.consented, userName));
    }
    return Promise.all(promises).then(([saveCall]) => saveCall);
  }
  setUserOnSiteMarketing(isOnsiteMarketingAllowed, userName) {
    const user = session.session.getUser();
    if (!user && !userName) {
      throw new Error("User not logged in or no userName given to setUserOnSiteMarketing call.");
    }
    return index.adapter.users.setUserOnSiteMarketing({
      userName: userName || user.userName,
      notOnSiteMarketing: !isOnsiteMarketingAllowed
    });
  }
  changeEmail(newEmail, password, lang) {
    return index.adapter.users.changeEmail({
      email: newEmail,
      password,
      lang
    });
  }
  closeAccount(currentPassword) {
    return index.adapter.users.closeAccount({ currentPassword });
  }
  closeAccountV2(params) {
    return index.adapter.users.closeAccountV2(params);
  }
  isEmailAvailable(email) {
    return index.adapter.users.isEmailAvailable({ email });
  }
  isUsernameAvailable(username) {
    return index.adapter.users.isUsernameAvailable({ username });
  }
  bonus(userName, slug, amount) {
    const params = { userName, slug, betAmount: amount };
    return index.adapter.users.bonus(params);
  }
  getSOWQ() {
    return __async(this, null, function* () {
      return normalize.normalize(yield index.adapter.users.getSOWQ()).sowQuestions.map((question) => {
        return {
          id: question.id,
          type: question.sowQuestionType,
          answers: question.sowAnswers.map((answer) => ({
            id: answer.id,
            answer: answer.text
          })),
          question: question.text
        };
      });
    });
  }
  getAmlVerificationStatus() {
    return __async(this, null, function* () {
      const verificationStatus = yield index.adapter.users.getAmlVerificationStatus();
      return {
        sowQuestionnaireStatus: verificationStatus.SOWQ || getAmlVerificationStatus.DocumentStatus.NOT_REQUESTED,
        sowDocumentsStatus: verificationStatus.SOWD && Object.entries(verificationStatus.SOWD).reduce((prev, [key, val]) => __spreadProps(__spreadValues({}, prev), {
          [key]: val || getAmlVerificationStatus.DocumentStatus.NOT_REQUESTED
        }), {}),
        sofStatus: verificationStatus.SOF || getAmlVerificationStatus.DocumentStatus.NOT_REQUESTED,
        address: verificationStatus.address,
        payment: verificationStatus.payment,
        photoID: verificationStatus.photoID,
        uploadCounter: verificationStatus.uploadCounter,
        uploadLimit: verificationStatus.uploadLimit,
        status: verificationStatus.status,
        bankIdBlocked: verificationStatus.bankIdBlocked,
        userName: verificationStatus.userName,
        id: verificationStatus.id
      };
    });
  }
  getGracePeriods() {
    return index.adapter.users.getGracePeriod();
  }
  getPreferences() {
    return index.adapter.users.getPreferences();
  }
  getRealityCheckOptions() {
    return index.adapter.users.getRealityCheckOptions();
  }
  getLoginHistory(limit) {
    return index.adapter.users.getLoginHistory({ limit });
  }
  hasPendingConsents() {
    return index.adapter.users.hasPendingConsents();
  }
  userPendingConsents(languageAlpha2Code) {
    const params = { languageAlpha2Code };
    return index.adapter.users.userPendingConsents(params);
  }
  setPreferences(params) {
    return index.adapter.users.setPreferences(params);
  }
  setRealityCheck(value) {
    const params = { value };
    return index.adapter.users.setRealityCheck(params);
  }
  verifyEmail(token, lang, geoResponse) {
    return __async(this, null, function* () {
      const params = { key: token, geoResponse, lang };
      const user = yield index.adapter.users.verifyEmail(params);
      session.session.create(user);
      return user;
    });
  }
  getRealityCheck() {
    return __async(this, null, function* () {
      const res = yield index.adapter.users.getRealityCheck();
      if (res && res.value) {
        return res.value;
      }
      return null;
    });
  }
  sessionTurnover() {
    return index.adapter.users.sessionTurnover();
  }
  postSOWQ(params) {
    return index.adapter.users.postSOWQ({
      SowQuestions: params.questions.map(({ questionId, answerIds }) => ({
        SowQuestionId: questionId,
        SowAnswerIds: answerIds
      }))
    });
  }
  impersonate(token) {
    return index.adapter.users.impersonate(token);
  }
  getIdDocTypes() {
    return __async(this, null, function* () {
      const res = yield index.adapter.users.getIdDocTypes();
      return Object.keys(res).map((key) => {
        return { name: key, id: res[key] };
      });
    });
  }
  getAmlStatus() {
    return index.adapter.users.getAmlStatus();
  }
  uploadKYC(params, requestDocs = false) {
    if (requestDocs) {
      return index.adapter.users.requestAndUploadKYC(params);
    }
    return index.adapter.users.uploadKYC(params);
  }
  getPepDetails() {
    return index.adapter.users.getPepDetails();
  }
  savePepDetails(params) {
    return index.adapter.users.savePepDetails(params);
  }
  updateLanguage(lang) {
    return index.adapter.users.updateLanguage(lang);
  }
  unsubscribeFromTags(user) {
    const tags = util.getUserTags(user);
    index.adapter.users.unsubscribe({ tags });
  }
  kycDocumentRequest(documentType) {
    const params = { documentType };
    return index.adapter.users.kycDocumentRequest(params);
  }
  verifyWithDataZoo(params) {
    return index.adapter.users.verifyWithDataZoo(params);
  }
  subscribeForTags(user) {
    const tags = util.getUserTags(user);
    index.adapter.users.subscribe({ tags });
  }
  listSecurityQuestions() {
    return index.adapter.users.listSecurityQuestions().then(normalize.normalize);
  }
  changeSecurityQuestion(params) {
    return index.adapter.users.changeSecurityQuestion(params);
  }
  getSecurityQuestion(email) {
    return __async(this, null, function* () {
      const questions = yield index.adapter.users.getSecurityQuestions({ email });
      return questions[0];
    });
  }
  getUserActiveBlocks() {
    return index.adapter.users.getUserActiveBlocks();
  }
  getKycVerificationUrl() {
    return index.adapter.users.getKycVerificationUrl();
  }
  notificationMessage(notificationType, content, isHtml) {
    let params = { type: notificationType };
    params = isHtml ? __spreadProps(__spreadValues({}, params), { contentHTML: content }) : __spreadProps(__spreadValues({}, params), { content });
    return index.adapter.users.notificationMessage(params);
  }
  linkSlotboxLandBaseUser() {
    return index.adapter.users.linkSlotboxLandBaseUser();
  }
  getAuthenticationMethod() {
    return index.adapter.users.getAuthenticationMethod();
  }
  setAuthenticationMethod(authenticationMethod) {
    return index.adapter.users.setAuthenticationMethod({ authenticationMethod });
  }
  getOmniUserDetails() {
    return index.adapter.users.getOmniUserDetails();
  }
  sendSMS() {
    return index.adapter.users.sendSMS();
  }
  getGameSessionSummary() {
    return index.adapter.users.getGameSessionSummary();
  }
  linkLandBased() {
    return index.adapter.users.linkLandBased();
  }
  registerMembership(params) {
    return index.adapter.users.membershipRegistration(params);
  }
}
const users = new Users();

exports.users = users;
